import { render, staticRenderFns } from "./ChapterMembers.vue?vue&type=template&id=a0a4ad80"
import script from "./ChapterMembers.vue?vue&type=script&lang=js"
export * from "./ChapterMembers.vue?vue&type=script&lang=js"
import style0 from "./ChapterMembers.vue?vue&type=style&index=0&id=a0a4ad80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports